import React, { useState, useEffect, useLayoutEffect } from 'react'

// Images
// import SearchIcon from 'img/icon/search.inline.svg'
import searchIcon from 'img/icon/search.svg'
import ButtonMinimal from 'components/elements/ButtonMinimal'
import { useInView } from 'react-hook-inview'

// Components
import ButtonDefault from 'components/elements/ButtonDefault'

// Third Party
import styled from 'styled-components'
import { useFlexSearch } from 'react-use-flexsearch'
import { useStaticQuery, graphql } from 'gatsby'
import { motion } from 'framer-motion'
import parse from 'html-react-parser'

const InputWrapper = styled.div`
  position: relative;
`

const Input = styled.input`
  background: ${(props) => props.theme.color.face.light};
  border-radius: 29.5px;
  z-index: 2;
  position: relative;
  border: none;
  padding: 0 10px 0 45px;
  height: 35px;
  width: 300px;
  display: flex;
  align-items: center;
  font-size: ${(props) => props.theme.font.size.l};

  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
    font-size: ${(props) => props.theme.font.size.l};
  }
`

const InputShadow = styled.div`
  position: absolute;
  height: calc(100% + 6px);
  width: calc(100% + 6px);
  top: -3px;
  left: -3px;
  z-index: 1;
  border-radius: 29.5px;
  background: ${(props) => props.theme.color.gradient.main};
`

const StyledSearchIcon = styled.img`
  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  z-index: 3;
  height: 26px;
  width: 26px;
`

const StyledSearch = styled.div``

const SearchResult = styled(motion.div)`
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  padding: 50px 40px 50px 40px;
  border-radius: 20px;
  margin: 20px 0 20px 0;
`

const Row = styled.div``

const Type = styled.p`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    background: ${(props) => props.theme.color.gradient.main};
    height: 3px;
    width: 100%;
    left: 0;
    bottom: 0;
  }
`

const Post = styled(motion.div)``
const InnerPost = styled.div``
const PostWrapper = styled.div`
  position: relative;
  top: -20px;
`
const PostContent = styled(motion.div)`
  width: 300px;
  border-radius: 20px;

  padding: 30px;
`

const Search = ({ className, onlyGemeentes = false }) => {
  const { gemeentes, posts, pages, cases } = useStaticQuery(graphql`
    {
      gemeentes: localSearchGemeentes {
        index
        store
      }
      posts: localSearchPosts {
        index
        store
      }
      pages: localSearchPages {
        index
        store
      }
      cases: localSearchCases {
        index
        store
      }
    }
  `)

  const [query, setQuery] = useState('')
  const pageResults = useFlexSearch(query, pages.index, JSON.parse(pages.store))

  const gemeentesResults = useFlexSearch(
    query,
    gemeentes.index,
    JSON.parse(gemeentes.store)
  )

  const postResults = useFlexSearch(query, posts.index, JSON.parse(posts.store))

  const caseResults = useFlexSearch(query, cases.index, JSON.parse(cases.store))

  function handleSearchChange(e) {
    setQuery(e.target.value)
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const params = urlParams.get('query')

    setQuery(params)
  }, [])

  const [ref, isVisible] = useInView({
    threshold: 0.3,
  })

  const [view, setView] = useState(false)

  useLayoutEffect(() => {
    if (isVisible && !view) {
      setView(true)
    }
  }, [isVisible])

  return (
    <StyledSearch className={`container ${className ? `${className}` : ``}`}>
      <div className="row">
        <div className="col-12 mb-5 d-flex justify-content-center">
          <InputWrapper>
            <Input
              type="search"
              className=""
              value={query}
              onChange={handleSearchChange}
              placeholder={onlyGemeentes ? 'Zoek een gemeente' : 'Zoeken'}
            />
            <StyledSearchIcon src={searchIcon} alt="" />
            <InputShadow />
          </InputWrapper>
        </div>
        {query && onlyGemeentes && gemeentesResults.length < 1 && (
          <p className="w-100 text-center">
            Geen gemeentes gevonden. Selecteer hieronder een provincie om
            gemeentes bij u in de buurt te tonen.
          </p>
        )}
        <div className="col-12">
          <Row className="row pb-5">
            {query !== null &&
              !onlyGemeentes &&
              pageResults.map((r) => (
                <div className="col-lg-3">
                  <SearchResult
                    initial={{ y: 50, opacity: 0.5 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{
                      duration: 0.8,
                      type: 'spring',
                    }}
                  >
                    <div>
                      <div className="d-flex justify-content-center pb-3">
                        {r.pageType ? (
                          <Type className="float-left mb-0 font-weight-xl font-size-xm">
                            {r.pageType}
                          </Type>
                        ) : (
                          <Type className="float-left mb-0 font-weight-xl font-size-xm">
                            {r.type}
                          </Type>
                        )}
                      </div>
                      <h2 className="mb-0 text-center font-weight-xl">
                        {parse(r.title)}
                      </h2>
                    </div>
                    <div className="d-flex justify-content-center pt-5">
                      <ButtonDefault to={r.path} icon="arrow">
                        <p>Ga naar resultaat</p>
                      </ButtonDefault>
                    </div>
                  </SearchResult>
                </div>
              ))}
            {query !== null &&
              !onlyGemeentes &&
              caseResults.map((r) => (
                <div className="col-lg-6">
                  <SearchResult
                    initial={{ y: 50, opacity: 0.5 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{
                      duration: 0.8,
                      type: 'spring',
                    }}
                  >
                    <div>
                      <div className="d-flex justify-content-center pb-3">
                        <Type className="float-left mb-0 font-weight-xl font-size-xm">
                          {r.type}
                        </Type>
                      </div>
                      <h2 className="mb-0 text-center font-weight-xl">
                        {parse(r.title)}
                      </h2>
                    </div>
                    <div className="d-flex justify-content-center pt-5">
                      <ButtonDefault to={r.path} icon="arrow">
                        <p>Ga naar resultaat</p>
                      </ButtonDefault>
                    </div>
                  </SearchResult>
                </div>
              ))}
            {query !== null &&
              !onlyGemeentes &&
              postResults.map((r) => (
                <div className="col-lg-4">
                  <SearchResult
                    initial={{ y: 50, opacity: 0.5 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{
                      duration: 0.8,
                      type: 'spring',
                    }}
                  >
                    <div>
                      <div className="d-flex justify-content-center pb-3">
                        <Type className="float-left mb-0 font-weight-xl font-size-xm">
                          {r.type}
                        </Type>
                      </div>
                      <h2 className="mb-0 text-center font-weight-xl">
                        {parse(r.title)}
                      </h2>
                    </div>
                    <div className="d-flex justify-content-center pt-5">
                      <ButtonDefault to={r.path} icon="arrow">
                        <p>Ga naar resultaat</p>
                      </ButtonDefault>
                    </div>
                  </SearchResult>
                </div>
              ))}
            {query !== null &&
              gemeentesResults.map((r, index) => (
                <>
                  {!onlyGemeentes ? (
                    <div className="col-lg-4">
                      <SearchResult
                        initial={{ y: 50, opacity: 0.5 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{
                          duration: 0.8,
                          type: 'spring',
                        }}
                      >
                        <div>
                          <div className="d-flex justify-content-center pb-3">
                            <Type className="float-left mb-0 font-weight-xl font-size-xm">
                              {r.type}
                            </Type>
                          </div>
                          <h2 className="mb-0 text-center font-weight-xl">
                            {parse(r.title)}
                          </h2>
                        </div>
                        <div className="d-flex justify-content-center pt-5">
                          <ButtonDefault to={r.path} icon="arrow">
                            <p>Ga naar resultaat</p>
                          </ButtonDefault>
                        </div>
                      </SearchResult>
                    </div>
                  ) : (
                    <Post
                      key={r.path}
                      className="col-lg-4 pb-5 d-flex justify-content-center"
                      whileHover="hover"
                      initial="rest"
                      animate={isVisible ? 'init' : 'rest'}
                      variants={{
                        hover: {},
                        rest: {
                          opacity: 1,
                          y: 30,
                        },
                        init: {
                          opacity: 1,
                          y: 0,
                          transition: {
                            delay: index * 0.2,
                            type: 'spring',
                            duration: 0.8,
                          },
                        },
                      }}
                    >
                      <InnerPost>
                        <PostWrapper className="d-flex justify-content-center">
                          <PostContent
                            variants={{
                              rest: {
                                backgroundColor: 'transparent',

                                boxShadow: '0 0 10px 0 rgba(0,0,0,0.3)',
                              },
                              hover: {
                                boxShadow: '0 0 10px 0 rgba(0,0,0,0.3)',
                                backgroundColor: '#ffffff',
                                transition: {
                                  duration: 0.15,
                                  type: 'spring',
                                },
                              },
                            }}
                          >
                            <div className="pt-3">
                              <h2 className="font-weight-xl font-size-ms">
                                {parse(r.title)}
                              </h2>
                            </div>
                            <div className="d-flex pt-2 justify-content-end">
                              <ButtonMinimal to={r.path} icon="arrow">
                                <p>Check de mogelijkheden</p>
                              </ButtonMinimal>
                            </div>
                          </PostContent>
                        </PostWrapper>
                      </InnerPost>
                    </Post>
                  )}
                </>
              ))}
          </Row>
        </div>
      </div>
    </StyledSearch>
  )
}

export default Search
